import { render } from "./content-classroom.vue?vue&type=template&id=e7eb5bc8&ts=true"
import script from "./content-classroom.vue?vue&type=script&lang=ts"
export * from "./content-classroom.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__